<template>
  <div class="cf-root">
    <div class="consult-float">
    <button
      type="button"
      class="cf-main"
      @click="toggle"
      aria-label="联系咨询">
      <svg viewBox="0 0 1024 1024" width="40" height="40"><path fill="currentColor" d="M512 96C264.6 96 64 268.6 64 481.5c0 122.4 66.3 231.2 169.9 301.6L208 928l143.4-86.4c50.7 14.1 105 21.9 160.6 21.9 247.4 0 448-172.6 448-385.5S759.4 96 512 96zm-160 416a48 48 0 1 1 0-96 48 48 0 0 1 0 96zm160 0a48 48 0 1 1 0-96 48 48 0 0 1 0 96zm160 0a48 48 0 1 1 0-96 48 48 0 0 1 0 96z"/></svg>
      <span class="cf-main-text">咨询</span>
      <span class="cf-pulse"></span>
      <span class="cf-pulse cf-pulse-delay"></span>
    </button>

    <transition name="cf-roll">
      <ul class="cf-actions" v-show="expanded">
        <li class="cf-action" @click="openDialog">
          <svg viewBox="0 0 1024 1024" width="28" height="28"><path fill="currentColor" d="M512 96C264.6 96 64 268.6 64 481.5c0 122.4 66.3 231.2 169.9 301.6L208 928l143.4-86.4c50.7 14.1 105 21.9 160.6 21.9 247.4 0 448-172.6 448-385.5S759.4 96 512 96zm-89.6 432.5l-112-112 39.6-39.6 72.4 72.4 184.4-184.4 39.6 39.6-224 224z"/></svg>
          <span class="cf-label">在线咨询</span>
        </li>
        <li class="cf-action">
          <svg viewBox="0 0 1024 1024" width="28" height="28"><path fill="currentColor" d="M758.2 624.6c-15.6-7.9-91.9-45.3-106.1-50.5-14.2-5.2-24.6-7.8-35 7.8-10.4 15.6-40.1 50.5-49.2 60.9-9.1 10.4-18.1 11.7-33.7 3.9-15.6-7.8-65.7-24.2-125.2-77.2-46.3-41.3-77.5-92.3-86.6-107.9-9.1-15.6-1-24.1 6.8-31.9 7-7 15.6-18.2 23.4-27.3 7.8-9.1 10.4-15.6 15.6-26 5.2-10.4 2.6-19.5-1.3-27.3-3.9-7.8-35-84.3-47.9-115.4-12.6-30.3-25.5-26.2-35-26.7-9.1-.5-19.5-.6-29.9-.6-10.4 0-27.3 3.9-41.6 19.5-14.3 15.6-54.6 53.4-54.6 130s55.9 150.6 63.7 161c7.8 10.4 110 168 266.5 235.5 37.2 16.1 66.3 25.7 88.9 32.9 37.3 11.9 71.3 10.2 98.2 6.2 30-4.5 91.9-37.5 104.8-73.7 12.9-36.2 12.9-67.3 9.1-73.7-3.9-6.4-14.3-10.3-29.9-18.2z"/><path fill="currentColor" d="M512 64C264.6 64 64 264.6 64 512c0 88.5 25.7 170.8 70 240.2L96 928l180.1-37.5C347.4 936.7 427.3 960 512 960c247.4 0 448-200.6 448-448S759.4 64 512 64zm0 819.2c-76.8 0-148.5-21.3-209.7-58.3l-15-9-115.7 24.1 24.7-112.7-9.8-15.5C148.7 651.1 124.8 583.5 124.8 512 124.8 298.5 298.5 124.8 512 124.8S899.2 298.5 899.2 512 725.5 883.2 512 883.2z"/></svg>
          <span class="cf-label">微信咨询</span>
          <div class="cf-popover cf-popover-wechat">
            <div class="cf-pop-title">扫码添加客服微信</div>
            <div class="cf-qrcode">
              <div class="cf-qrcode-placeholder">
                <svg viewBox="0 0 100 100" width="120" height="120"><rect width="100" height="100" fill="#fff"/><g fill="#3E2D20"><rect x="8" y="8" width="22" height="22"/><rect x="14" y="14" width="10" height="10" fill="#fff"/><rect x="70" y="8" width="22" height="22"/><rect x="76" y="14" width="10" height="10" fill="#fff"/><rect x="8" y="70" width="22" height="22"/><rect x="14" y="76" width="10" height="10" fill="#fff"/><rect x="38" y="10" width="6" height="6"/><rect x="50" y="14" width="6" height="6"/><rect x="60" y="10" width="4" height="4"/><rect x="40" y="24" width="8" height="6"/><rect x="56" y="24" width="6" height="6"/><rect x="10" y="40" width="6" height="6"/><rect x="22" y="38" width="8" height="8"/><rect x="36" y="40" width="6" height="6"/><rect x="48" y="38" width="10" height="10"/><rect x="64" y="40" width="6" height="6"/><rect x="76" y="40" width="8" height="6"/><rect x="86" y="48" width="6" height="6"/><rect x="14" y="54" width="6" height="6"/><rect x="28" y="52" width="8" height="8"/><rect x="42" y="56" width="6" height="6"/><rect x="56" y="54" width="6" height="6"/><rect x="68" y="52" width="10" height="10"/><rect x="82" y="60" width="6" height="6"/><rect x="38" y="68" width="8" height="6"/><rect x="50" y="68" width="6" height="6"/><rect x="60" y="68" width="6" height="6"/><rect x="74" y="74" width="6" height="6"/><rect x="86" y="74" width="6" height="6"/><rect x="40" y="82" width="6" height="6"/><rect x="52" y="80" width="10" height="10"/><rect x="68" y="86" width="6" height="6"/></g></svg>
              </div>
            </div>
            <div class="cf-pop-desc">微信号：qfyd2013</div>
          </div>
        </li>
        <li class="cf-action">
          <svg viewBox="0 0 1024 1024" width="28" height="28"><path fill="currentColor" d="M885.6 230.2L744.3 88.9c-25-25-65.5-25-90.5 0L582.5 160c-25 25-25 65.5 0 90.5l53 53c-39.7 90.1-115.9 166.2-205.9 205.9l-53-53c-25-25-65.5-25-90.5 0L215 527.6c-25 25-25 65.5 0 90.5l141.3 141.3c25 25 65.5 25 90.5 0 251.4-117.5 451-317.1 568.5-568.5 25-25 25-65.5 0-90.5z"/></svg>
          <span class="cf-label">电话咨询</span>
          <div class="cf-popover cf-popover-phone">
            <div class="cf-pop-title">客服热线</div>
            <div class="cf-phone-num">138 1716 6429</div>
            <div class="cf-pop-desc">工作日 9:00 - 18:00</div>
          </div>
        </li>
        <li class="cf-action cf-top" @click="backToTop">
          <svg viewBox="0 0 1024 1024" width="28" height="28"><path fill="currentColor" d="M512 192L192 512h192v320h256V512h192z"/></svg>
          <span class="cf-label">回到顶部</span>
        </li>
      </ul>
    </transition>
    </div>

    <div class="cf-dialog-mask" v-if="dialogOpen" @click.self="dialogOpen = false">
      <div class="cf-dialog">
        <div class="cf-dialog-head">
          <div class="cf-dialog-title">
            <svg viewBox="0 0 1024 1024" width="20" height="20"><path fill="currentColor" d="M512 96C264.6 96 64 268.6 64 481.5c0 122.4 66.3 231.2 169.9 301.6L208 928l143.4-86.4c50.7 14.1 105 21.9 160.6 21.9 247.4 0 448-172.6 448-385.5S759.4 96 512 96z"/></svg>
            <span>在线咨询</span>
          </div>
          <button type="button" class="cf-dialog-close" @click="dialogOpen = false" aria-label="关闭">
            <svg viewBox="0 0 1024 1024" width="16" height="16"><path fill="currentColor" d="M941.6 184.2L839.8 82.4 512 410.2 184.2 82.4 82.4 184.2 410.2 512 82.4 839.8l101.8 101.8L512 613.8l327.8 327.8 101.8-101.8L613.8 512z"/></svg>
          </button>
        </div>
        <div class="cf-dialog-body">
          <div class="cf-dialog-intro">
            您好，欢迎咨询尚博慧。请留下您的联系方式，我们将尽快与您取得联系。
          </div>
          <div class="cf-form-row">
            <label>称呼</label>
            <input type="text" placeholder="请输入您的称呼" />
          </div>
          <div class="cf-form-row">
            <label>手机号</label>
            <input type="text" placeholder="请输入联系电话" />
          </div>
          <div class="cf-form-row">
            <label>咨询内容</label>
            <textarea rows="4" placeholder="请简要描述您想咨询的问题"></textarea>
          </div>
          <div class="cf-dialog-tip">
            <span class="cf-dot"></span>
            提交后客服会在 1 个工作日内与您联系
          </div>
        </div>
        <div class="cf-dialog-foot">
          <button type="button" class="cf-btn cf-btn-ghost" @click="dialogOpen = false">稍后再说</button>
          <button type="button" class="cf-btn cf-btn-primary" @click="submitConsult">提交咨询</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConsultFloat',
  data () {
    return {
      expanded: false,
      dialogOpen: false
    }
  },
  mounted () {
    document.addEventListener('click', this.handleOutside)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleOutside)
  },
  methods: {
    toggle () {
      this.expanded = !this.expanded
    },
    openDialog () {
      this.dialogOpen = true
      this.expanded = false
    },
    backToTop () {
      const step = Math.max(40, window.scrollY / 20)
      const tick = () => {
        if (window.scrollY <= 0) return
        window.scrollBy(0, -step)
        window.requestAnimationFrame(tick)
      }
      tick()
    },
    submitConsult () {
      this.dialogOpen = false
    },
    handleOutside (e) {
      if (!this.$el.contains(e.target)) {
        this.expanded = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$brand: #A37135;
$brand-dark: #7D4D36;
$brand-deep: #3E2D20;
$brand-soft: #F6EFE2;
$brand-ink: #B89B70;

.consult-float {
  position: fixed;
  left: 60px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9999;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.cf-main {
  position: relative;
  width: 84px;
  height: 84px;
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: 50%;
  color: #fff;
  background: linear-gradient(135deg, #B98349 0%, $brand 45%, $brand-dark 100%);
  box-shadow: 0 10px 28px rgba(125, 77, 54, 0.38), 0 2px 6px rgba(62, 45, 32, 0.25);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: box-shadow 0.25s ease;

  svg { margin-bottom: 2px; }
  .cf-main-text {
    font-size: 13px;
    letter-spacing: 2px;
    line-height: 1;
  }

  &:hover {
    box-shadow: 0 14px 34px rgba(125, 77, 54, 0.45), 0 3px 8px rgba(62, 45, 32, 0.3);
  }
}

.cf-pulse {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 3px solid rgba(163, 113, 53, 0.7);
  box-shadow: 0 0 20px rgba(163, 113, 53, 0.45);
  animation: cf-pulse 1.8s ease-out infinite;
  pointer-events: none;
}
.cf-pulse-delay {
  border-color: rgba(185, 131, 73, 0.55);
  animation-delay: 0.9s;
}
@keyframes cf-pulse {
  0%   { transform: scale(1);    opacity: 0.85; }
  70%  { transform: scale(2.1);  opacity: 0; }
  100% { transform: scale(2.1);  opacity: 0; }
}

.cf-actions {
  list-style: none;
  margin: 0 0 0 14px;
  padding: 8px 10px;
  background: #fff;
  border-radius: 50px;
  box-shadow: 0 12px 30px rgba(62, 45, 32, 0.18), 0 2px 6px rgba(62, 45, 32, 0.08);
  border: 1px solid rgba(163, 113, 53, 0.15);
  display: flex;
  flex-direction: row;
  align-items: center;
  transform-origin: left center;
}

.cf-action {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 68px;
  border-radius: 12px;
  color: #6b5644;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;

  & + & { border-left: 1px dashed rgba(163, 113, 53, 0.18); }

  .cf-label {
    font-size: 12px;
    margin-top: 5px;
    letter-spacing: 0.5px;
  }

  &:hover {
    background: $brand-soft;
    color: $brand-dark;

    .cf-popover { opacity: 1; visibility: visible; transform: translateX(-50%) translateY(0); }
  }
}

.cf-popover {
  position: absolute;
  bottom: calc(100% + 14px);
  left: 50%;
  transform: translateX(-50%) translateY(8px);
  min-width: 180px;
  background: #fff;
  border-radius: 12px;
  padding: 14px 16px;
  box-shadow: 0 12px 30px rgba(62, 45, 32, 0.2);
  border: 1px solid rgba(163, 113, 53, 0.15);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, transform 0.2s ease;
  text-align: center;
  color: $brand-deep;

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: #fff;
  }

  .cf-pop-title {
    font-size: 13px;
    color: $brand-dark;
    margin-bottom: 8px;
  }
  .cf-pop-desc {
    font-size: 12px;
    color: #8a7560;
    margin-top: 6px;
  }
}

.cf-popover-phone {
  .cf-phone-num {
    font-size: 18px;
    font-weight: 600;
    color: $brand;
    letter-spacing: 1px;
  }
}

.cf-popover-wechat {
  .cf-qrcode {
    display: flex;
    justify-content: center;
    padding: 4px;
    background: $brand-soft;
    border-radius: 8px;
  }
  .cf-qrcode-placeholder {
    background: #fff;
    padding: 6px;
    border-radius: 6px;
    line-height: 0;
  }
}

.cf-roll-enter-active {
  transition: transform 0.55s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.35s ease;
}
.cf-roll-leave-active {
  transition: transform 0.45s cubic-bezier(0.55, 0, 0.55, 0.2), opacity 0.3s ease;
}
.cf-roll-enter {
  opacity: 0;
  transform: translateX(-60px) rotate(-180deg);
}
.cf-roll-enter-to {
  opacity: 1;
  transform: translateX(0) rotate(0);
}
.cf-roll-leave {
  opacity: 1;
  transform: translateX(0) rotate(0);
}
.cf-roll-leave-to {
  opacity: 0;
  transform: translateX(-60px) rotate(-180deg);
}

.cf-dialog-mask {
  position: fixed;
  inset: 0;
  background: rgba(62, 45, 32, 0.45);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: cf-fade 0.2s ease;
}
@keyframes cf-fade { from { opacity: 0; } to { opacity: 1; } }

.cf-dialog {
  width: 460px;
  max-width: 92vw;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(62, 45, 32, 0.35);
  animation: cf-pop 0.25s ease;
}
@keyframes cf-pop {
  from { transform: translateY(20px) scale(0.96); opacity: 0; }
  to   { transform: translateY(0)    scale(1);    opacity: 1; }
}

.cf-dialog-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: linear-gradient(135deg, $brand 0%, $brand-dark 100%);
  color: #fff;

  .cf-dialog-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    letter-spacing: 1px;
    svg { margin-right: 8px; }
  }
  .cf-dialog-close {
    width: 28px;
    height: 28px;
    border: none;
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease, transform 0.4s ease;
    &:hover { background: rgba(255, 255, 255, 0.28); transform: rotate(180deg); }
  }
}

.cf-dialog-body {
  padding: 22px 24px 4px;
}

.cf-dialog-intro {
  font-size: 13px;
  color: #7a6553;
  background: $brand-soft;
  border-left: 3px solid $brand;
  padding: 10px 12px;
  border-radius: 0 8px 8px 0;
  margin-bottom: 18px;
  line-height: 1.6;
}

.cf-form-row {
  margin-bottom: 14px;
  label {
    display: block;
    font-size: 13px;
    color: $brand-deep;
    margin-bottom: 6px;
  }
  input, textarea {
    width: 100%;
    box-sizing: border-box;
    padding: 9px 12px;
    border: 1px solid #e2d6c4;
    border-radius: 8px;
    font-size: 13px;
    color: #3E2D20;
    background: #fdfaf5;
    outline: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    font-family: inherit;
    resize: vertical;
    &:focus {
      border-color: $brand;
      box-shadow: 0 0 0 3px rgba(163, 113, 53, 0.15);
      background: #fff;
    }
  }
}

.cf-dialog-tip {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: $brand-ink;
  margin: 4px 0 16px;
  .cf-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: $brand;
    margin-right: 6px;
  }
}

.cf-dialog-foot {
  display: flex;
  justify-content: flex-end;
  padding: 0 24px 22px;
  gap: 10px;
}

.cf-btn {
  min-width: 96px;
  height: 36px;
  border-radius: 8px;
  font-size: 13px;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;
  letter-spacing: 1px;
}
.cf-btn-ghost {
  background: #fff;
  border: 1px solid #d9c8b1;
  color: #7a6553;
  &:hover { background: $brand-soft; color: $brand-dark; }
}
.cf-btn-primary {
  background: linear-gradient(135deg, $brand 0%, $brand-dark 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(125, 77, 54, 0.28);
  &:hover { transform: translateY(-1px); box-shadow: 0 6px 16px rgba(125, 77, 54, 0.36); }
}
</style>



// WEBPACK FOOTER //
// ConsultFloat.vue?25bdd0dc